module.exports = __webpack_public_path__ + "img/aa05eb7852852116d54f3ad32d856353584710e2.d15fb1f7.png";